module.exports = __webpack_public_path__ + "assets/b77.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b77.png
// module id = 668
// module chunks = 0